import { useTranslation } from 'react-i18next';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'fa' ? 'en' : 'fa';
    i18n.changeLanguage(newLang);
    
    // Update document direction and language
    document.documentElement.dir = newLang === 'fa' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
    document.body.lang = newLang;
  };

  return (
    <button
      onClick={toggleLanguage}
      className="btn btn-outline"
      aria-label="Switch language"
    >
      {i18n.language === 'fa' ? 'English' : 'فارسی'}
    </button>
  );
}
